var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "progress",
    class: _vm.backgroundClass,
    style: {
      width: _vm.percent + "%",
      height: _vm.height,
      opacity: _vm.show ? 1 : 0,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }